AppTabs.createTab( {
name: 'delivery-mode',
icon: 'vial',
text: 'Delivery Mode',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-delivery-mode',

		readTableName: 	'tblDeliveryMode',
		editTableName: 	'tblDeliveryMode',
		primaryKey: 	'DeliveryModeID',

		canCreate: 			true,
		canEdit: 			true,
		canRemove: 			true,
		canSearch:          true,
		hasColumnFilters: 	false,

		actionData:			'datatable',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'deliveryModeOptions' );
		},

		fields: [
			{
				label: 		'Delivery Mode',
				columnName: 'DeliveryMode',
				isEditable: true,
			},
		],

	} );
}

} );
